var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-container",
    [
      _c("el-header", [
        _c("img", {
          staticClass: "logo",
          attrs: { src: require("@/assets/image/xunyu.png") },
        }),
        _vm._v(" "),
        _c("div", { staticClass: "help" }, [
          _c("img", { attrs: { src: require("@/assets/image/help.png") } }),
          _vm._v(" "),
          _c("img", {
            staticClass: "user",
            attrs: { src: require("@/assets/image/user.png") },
          }),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "el-main",
        [
          _c(
            "el-row",
            { attrs: { id: "menu" } },
            [
              _c(
                "el-col",
                { staticClass: "item", attrs: { xs: 12, sm: 8, lg: 6 } },
                [
                  _c("a", { attrs: { href: "/index" } }, [
                    _c("img", {
                      attrs: { src: require("@/assets/menu/nav_icon_1.png") },
                    }),
                    _vm._v(" "),
                    _c("p", [_vm._v("图片管理")]),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { staticClass: "item", attrs: { xs: 12, sm: 8, lg: 6 } },
                [
                  _c("a", { attrs: { href: "/index" } }, [
                    _c("img", {
                      attrs: { src: require("@/assets/menu/nav_icon_2.png") },
                    }),
                    _vm._v(" "),
                    _c("p", [_vm._v("图片管理")]),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { staticClass: "item", attrs: { xs: 12, sm: 8, lg: 6 } },
                [
                  _c("a", { attrs: { href: "/index" } }, [
                    _c("img", {
                      attrs: { src: require("@/assets/menu/nav_icon_3.png") },
                    }),
                    _vm._v(" "),
                    _c("p", [_vm._v("图片管理")]),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { staticClass: "item", attrs: { xs: 12, sm: 8, lg: 6 } },
                [
                  _c("a", { attrs: { href: "/index" } }, [
                    _c("img", {
                      attrs: { src: require("@/assets/menu/nav_icon_4.png") },
                    }),
                    _vm._v(" "),
                    _c("p", [_vm._v("图片管理")]),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { staticClass: "item", attrs: { xs: 12, sm: 8, lg: 6 } },
                [
                  _c("a", { attrs: { href: "/index" } }, [
                    _c("img", {
                      attrs: { src: require("@/assets/menu/nav_icon_5.png") },
                    }),
                    _vm._v(" "),
                    _c("p", [_vm._v("图片管理")]),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { staticClass: "item", attrs: { xs: 12, sm: 8, lg: 6 } },
                [
                  _c("img", {
                    attrs: { src: require("@/assets/menu/nav_icon_6.png") },
                  }),
                  _vm._v(" "),
                  _c("p", [_vm._v("图片管理")]),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { staticClass: "item", attrs: { xs: 12, sm: 8, lg: 6 } },
                [
                  _c("img", {
                    attrs: { src: require("@/assets/menu/nav_icon_7.png") },
                  }),
                  _vm._v(" "),
                  _c("p", [_vm._v("图片管理")]),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { staticClass: "item", attrs: { xs: 12, sm: 8, lg: 6 } },
                [
                  _c("img", {
                    attrs: { src: require("@/assets/menu/nav_icon_8.png") },
                  }),
                  _vm._v(" "),
                  _c("p", [_vm._v("图片管理")]),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }